import { render, staticRenderFns } from "./media_holding_history_dialog.vue?vue&type=template&id=c920f896&scoped=true"
import script from "./media_holding_history_dialog.vue?vue&type=script&lang=js"
export * from "./media_holding_history_dialog.vue?vue&type=script&lang=js"
import style0 from "./media_holding_history_dialog.vue?vue&type=style&index=0&id=c920f896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c920f896",
  null
  
)

export default component.exports